import { EEnvironment } from 'server/types/EEnvironment';

export const IS_STATIC_ERROR = process.env.STATIC_ERROR;
export const ON_PREMISE = String(process.env.ON_PREMISE) === '1';
export const BUILD = String(process.env.BUILD || '');
export const BUILD_RISK = String(process.env.BUILD_RISK);
export const BUILD_COMMIT = String(process.env.BUILD_COMMIT);
export const BUILD_SLUG = String(process.env.BUILD_SLUG);
export const ENVIRONMENT = (process.env.NODE_ENV || EEnvironment.DEV) as EEnvironment;
